// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2_82o","intIcon":"intIcon__3eCrq"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/scss/gemView.scss
// module id = hJ0q
// module chunks = 0